import Vue from "vue";
import Router from "vue-router";

// Layout
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";

// Templates
import Components from "./templates/Components.vue";
import Landing from "./templates/Landing.vue";
import LandingOptional from "./templates/LandingOptional.vue";
import Login from "./templates/Login.vue";
import Register from "./templates/Register.vue";
import Profile from "./templates/Profile.vue";

// Pages
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Relations from "./views/Relations.vue";
import Project from "./views/Relation.vue";
import References from "./views/References";
import Reference from "./views/Reference";
import Contact from "./views/Contact.vue";
import Error404 from "./views/Error404.vue";
import VueRouter from "vue-router";

Vue.use(Router);

const routes = [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      },
      meta: {
        title: 'Home Page - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The home page of the Marvelous site.'
          },
          {
            property: 'og:description',
            content: 'The home page of the Marvelous site.'
          }
        ]
      }
    },
    {
      path: "/about",
      name: "about",
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      },
      meta: {
        title: 'About - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The about Marvelous page.'
          },
          {
            property: 'og:description',
            content: 'The about Marvelous page.'
          }
        ]
      }
    },
    {
      path: "/relations",
      name: "relations",
      components: {
        header: AppHeader,
        default: Relations,
        footer: AppFooter
      },
      meta: {
        title: 'Relations - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The relations Marvelous page.'
          },
          {
            property: 'og:description',
            content: 'The relations Marvelous page.'
          }
        ]
      }
    },
    {
      path: "/relation/:id",
      name: "relation",
      components: {
        header: AppHeader,
        default: Project,
        footer: AppFooter
      },
      meta: {
        title: 'Relation - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The relation Marvelous page.'
          },
          {
            property: 'og:description',
            content: 'The relation Marvelous page.'
          }
        ]
      }
    },
    {
      path: "/references",
      name: "references",
      components: {
        header: AppHeader,
        default: References,
        footer: AppFooter
      },
      meta: {
        title: 'References - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The references Marvelous page.'
          },
          {
            property: 'og:description',
            content: 'The references Marvelous page.'
          }
        ]
      }
    },
    {
      path: "/reference/:id",
      name: "reference",
      components: {
        header: AppHeader,
        default: Reference,
        footer: AppFooter
      },
      meta: {
        title: 'Reference - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The reference Marvelous page.'
          },
          {
            property: 'og:description',
            content: 'The reference Marvelous page.'
          }
        ]
      }
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      },
      meta: {
        title: 'Contact - Marvelous',
        metaTags: [
          {
            name: 'description',
            content: 'The contact Marvelous page.'
          },
          {
            property: 'og:description',
            content: 'The contact Marvelous page.'
          }
        ]
      }
    },
    // Note:
    // Below are all the component & template pages based on the requirements.
    // Please consider to split them before pushing this project to production.
    //
    // ~ Templates ~ START
    {
      path: "/templates",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/templates-landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/templates-landing-optional",
      name: "landing",
      components: {
        header: AppHeader,
        default: LandingOptional,
        footer: AppFooter
      }
    },
    {
      path: "/templates-login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/templates-register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/templates-profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    // ~ Templates ~ END
    //
    // Note
    // Your server will no longer report 404 errors as all not-found paths now serve up your index.html file.
    // To get around the issue, you should implement a catch-all route within your Vue app to show a 404 page:
    {
      path: "*",
      name: "Error404",
      components: {
        header: AppHeader,
        default: Error404,
        footer: AppFooter
      }
    },
  ],

  router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior: to => {
      if (to.hash) {
        return {selector: to.hash};
      } else {
        return {x: 0, y: 0};
      }
    }
  })

// Note
// This is a navigation guard that allows you to set specific metadata per page per language.
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
